// @flow
import {
    ADD_NEW_DASHBOARD_PAGE,
    CANCEL_DASHBOARD_EDIT,
    CHANGE_CURRENT_DASHBOARD_PAGE,
    DASHBOARD_ADD_NEXT_PRODUCT_POSITION,
    DASHBOARD_ADD_PRODUCT,
    DASHBOARD_ADD_PRODUCT_OFF,
    DASHBOARD_ADD_PRODUCT_ON,
    DASHBOARD_EDIT_ON,
    DASHBOARD_REMOVE_PRODUCTS,
    DELETE_CELL,
    DISPLAY_ALL_PRODUCTS,
    GET_DASHBOARD_CUSTOMISATION,
    RECEIVE_DASHBOARD_CUSTOMISATION,
    SAVE_DASHBOARD_SUCCESS,
    UPDATE_CELL_POSITION,
    REDIRECT_TO_POSTINSTALL_GROUPS
} from './constants';
import {
    REMOVE_DEVICE,
    REMOVE_DEVICE_ERROR,
    REMOVE_ZONE,
    REMOVED_DEVICE,
    REMOVED_ZONE
} from '~/core/state/devices/constants';
import productsAsDefaultCustomisation from './productsAsDefaultCustomisation';
import dashboardItemPositionById from './dashboardItemPositionById';
import { fromJS, List, Map } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';
import { HIVE2_UPGRADE_START } from '~/core/state/install-upgrade-thermostat/hive2/constants';
import nextAvailableProductSlot from './nextAvailableProductSlot';

const initialState = fromJS({
    currentPage: 0,
    customisation: {},
    idsToBeDeleted: [],
    previousCustomisation: undefined,
    displayAllProducts: false,
    hasUnsavedChanges: false,
    isEditModeOn: false,
    isFetching: false,
    isLoaded: false,
    isAddModeOn: false,
    nextAddProductPosition: undefined,
    lastProductAdded: undefined,
    lastProductSwapped: undefined,
    removedDevices: [],
    shouldRedirectToPostinstallGroups: false
});

const setReceiveCustomisationState = (state: any, customisationData: any) =>
    state.withMutations(state =>
        state
            .set('isFetching', false)
            .set('isLoaded', true)
            .set('customisation', customisationData)
    );

const handlers = {
    // $FlowFixMe
    [GET_DASHBOARD_CUSTOMISATION]: handleReduce(state => state.set('isFetching', true)),
    // $FlowFixMe
    [CHANGE_CURRENT_DASHBOARD_PAGE]: handleReduce((state, { payload }) => state.set('currentPage', payload)),
    [RECEIVE_DASHBOARD_CUSTOMISATION]: handleReduce((state, { payload }) => {
        const { actions, customisation, products } = payload;

        if (!customisation || !customisation.pages) {
            if (products.size > 0) {
                return setReceiveCustomisationState(state, productsAsDefaultCustomisation(products));
            }
            return state;
        }

        if (customisation.pages.length === 0) {
            return setReceiveCustomisationState(state, productsAsDefaultCustomisation(products));
        }

        if (products.size > 0) {
            // $FlowFixMe
            const filteredCustomisationData = fromJS(customisation.pages).map(cp =>
                cp.set(
                    'items',
                    cp
                        .get('items')
                        .filter(
                            item =>
                                products.some(p => p.get('id') === item.get('id')) ||
                                actions.some(a => a.id === item.get('id'))
                        )
                )
            );

            const isEmpty = filteredCustomisationData.filter(cp => cp.get('items').count()).count() === 0;

            return isEmpty
                ? setReceiveCustomisationState(state, productsAsDefaultCustomisation(products))
                : setReceiveCustomisationState(
                      state,
                      fromJS({ lastUpdated: customisation.lastUpdated, pages: filteredCustomisationData })
                  );
        }
    }),
    [SAVE_DASHBOARD_SUCCESS]: handleReduce((state, { payload }) =>
        // $FlowFixMe
        state.withMutations(state =>
            state
                .set('customisation', payload)
                .set('isEditModeOn', false)
                .set('previousCustomisation', undefined)
                .set('lastProductAdded', undefined)
                .set('lastProductSwapped', undefined)
                .set('hasUnsavedChanges', false)
                .set('idsToBeDeleted', new List())
                .set('isLoaded', true)
        )
    ),
    // $FlowFixMe
    [DISPLAY_ALL_PRODUCTS]: handleReduce((state, { payload }) => state.set('displayAllProducts', payload)),
    [DASHBOARD_EDIT_ON]: handleReduce(state => {
        // $FlowFixMe
        const currentCustomisationState = state.getIn(['customisation', 'pages']);
        // $FlowFixMe
        const pages = state.getIn(['customisation', 'pages']);
        const newPosition = pages.count();
        const newPage = pages.push(
            fromJS({
                items: [],
                position: newPosition
            })
        );

        // $FlowFixMe
        return state.withMutations(state =>
            state
                .set('isEditModeOn', true)
                .setIn(['customisation', 'pages'], newPage)
                .set('previousCustomisation', currentCustomisationState)
        );
    }),
    [CANCEL_DASHBOARD_EDIT]: handleReduce(state => {
        // $FlowFixMe
        const previousCustomisation = state.get('previousCustomisation');

        if (previousCustomisation) {
            // $FlowFixMe
            return state.withMutations(state =>
                state
                    .setIn(['customisation', 'pages'], previousCustomisation)
                    .set('previousCustomisation', undefined)
                    .set('lastProductAdded', undefined)
                    .set('hasUnsavedChanges', false)
                    .set('isEditModeOn', false)
                    .set('idsToBeDeleted', new List())
            );
        } else {
            // $FlowFixMe
            return state.set('isEditModeOn', false);
        }
    }),
    [UPDATE_CELL_POSITION]: handleReduce((state, { payload }) => {
        const { currentPosition, newDropPosition, dragId } = payload;

        const [dropItemPageIndex, dropItemPositionIndex] = newDropPosition.split(':');
        const [dragItemPageIndex, dragItemPositionIndex] = currentPosition.split(':');

        const updatedCell = fromJS({
            id: dragId,
            position: parseInt(dropItemPositionIndex, 10),
            type: 'node'
        });

        const dragItemPagePath = ['customisation', 'pages', dragItemPageIndex, 'items'];
        // $FlowFixMe
        const dragItemIndex = state.getIn([...dragItemPagePath]).findIndex(p => p.get('id') === dragId);
        // $FlowFixMe
        const previousCustomisation = state.get('previousCustomisation');
        let newState = state;

        if (!previousCustomisation) {
            // $FlowFixMe
            const currentCustomisationState = state.getIn(['customisation', 'pages']);
            // $FlowFixMe
            newState = state.set('previousCustomisation', currentCustomisationState);
        }

        // $FlowFixMe
        newState = newState.deleteIn([...dragItemPagePath, dragItemIndex]);

        const dropItemPagePath = ['customisation', 'pages', dropItemPageIndex, 'items'];
        const dropItemPageEndIndex = newState.getIn([...dropItemPagePath]).count();
        newState = newState.setIn([...dropItemPagePath, dropItemPageEndIndex], updatedCell);

        // $FlowFixMe
        const existingItem = state
            .getIn([...dropItemPagePath])
            .find(p => p.get('position') === parseInt(dropItemPositionIndex, 10) && p.get('id') !== dragId);

        if (existingItem) {
            const existingItemIndex = newState
                .getIn([...dropItemPagePath])
                .findIndex(p => p.get('position') === parseInt(dropItemPositionIndex, 10) && p.get('id') !== dragId);
            newState = newState.deleteIn([...dropItemPagePath, existingItemIndex]);

            const dragItemPageEndIndex = newState.getIn([...dragItemPagePath]).count();
            const updatedExistingItem = existingItem.set('position', parseInt(dragItemPositionIndex, 10));
            newState = newState.withMutations(tempState =>
                tempState
                    .setIn([...dragItemPagePath, dragItemPageEndIndex], updatedExistingItem)
                    .set('lastProductSwapped', existingItem.get('id'))
            );
        }

        return newState;
    }),
    [DELETE_CELL]: handleReduce((state, { payload }) => {
        const { position } = payload;
        const [page, pagePosition] = position.split(':');
        // $FlowFixMe
        const index = state
            .getIn(['customisation', 'pages', page, 'items'])
            .findIndex(m => m.get('position') === parseInt(pagePosition, 10));

        // $FlowFixMe
        const idToBeDeleted = state.getIn(['customisation', 'pages', page, 'items', index, 'id']);
        // $FlowFixMe
        const nextIdsToBeDeletedIndex = state.get('idsToBeDeleted').size;

        // $FlowFixMe
        const previousCustomisation = state.get('previousCustomisation');
        if (!previousCustomisation) {
            // $FlowFixMe
            const currentCustomisationState = state.getIn(['customisation', 'pages']);
            // $FlowFixMe
            return state.withMutations(s =>
                s
                    .set('previousCustomisation', currentCustomisationState)
                    .setIn(['idsToBeDeleted', nextIdsToBeDeletedIndex], idToBeDeleted)
                    .deleteIn(['customisation', 'pages', page, 'items', index])
            );
        }

        // $FlowFixMe
        return state.withMutations(s =>
            s
                .deleteIn(['customisation', 'pages', page, 'items', index])
                .setIn(['idsToBeDeleted', nextIdsToBeDeletedIndex], idToBeDeleted)
        );
    }),
    [ADD_NEW_DASHBOARD_PAGE]: handleReduce(state => {
        // $FlowFixMe
        const pages = state.getIn(['customisation', 'pages']);
        const newPosition = pages.count();
        const newPage = pages.push(
            fromJS({
                items: [],
                position: newPosition
            })
        );

        // $FlowFixMe
        const previousCustomisation = state.get('previousCustomisation');

        if (!previousCustomisation) {
            // $FlowFixMe
            const currentCustomisationState = state.getIn(['customisation', 'pages']);
            // $FlowFixMe
            return state.withMutations(state =>
                state.set('previousCustomisation', currentCustomisationState).setIn(['customisation', 'pages'], newPage)
            );
        }

        // $FlowFixMe
        return state.setIn(['customisation', 'pages'], newPage);
    }),
    // $FlowFixMe
    [DASHBOARD_ADD_PRODUCT_ON]: handleReduce(state => state.set('isAddModeOn', true)),
    [DASHBOARD_ADD_PRODUCT_OFF]: handleReduce(state =>
        // $FlowFixMe
        state.withMutations(state => state.set('isAddModeOn', false).set('nextAddProductPosition', undefined))
    ),
    [DASHBOARD_ADD_PRODUCT]: handleReduce((state, { payload: { productId, turnEditModeOn } }) => {
        // $FlowFixMe
        const nextAddProductPosition = state.get('nextAddProductPosition');
        // $FlowFixMe
        const nextAvailableSlot = nextAvailableProductSlot(state.getIn(['customisation', 'pages'], Map()));
        // $FlowFixMe
        const previousCustomisation = state.get('previousCustomisation');
        // $FlowFixMe
        const currentCustomisationState = state.getIn(['customisation', 'pages']);

        // $FlowFixMe
        const page = nextAddProductPosition ? nextAddProductPosition.get('page') : nextAvailableSlot.get('page');
        const pagePosition = nextAddProductPosition
            ? nextAddProductPosition.get('position')
            : // $FlowFixMe
              nextAvailableSlot.get('position');

        // $FlowFixMe
        if (page > -1 && pagePosition > -1) {
            // $FlowFixMe
            const itemPosition = state.getIn(['customisation', 'pages', page, 'items']).count();

            // $FlowFixMe
            return state.withMutations(state =>
                state
                    .setIn(
                        ['customisation', 'pages', page, 'items', itemPosition],
                        fromJS({ id: productId, position: pagePosition, type: 'node' })
                    )
                    .set(
                        'previousCustomisation',
                        !previousCustomisation ? currentCustomisationState : previousCustomisation
                    )
                    .set('nextAddProductPosition', undefined)
                    .set('isAddModeOn', false)
                    .set('isEditModeOn', turnEditModeOn)
                    .set('lastProductAdded', productId)
                    .set('currentPage', page)
                    .set('hasUnsavedChanges', true)
            );
        } else {
            // $FlowFixMe
            const pages = state.getIn(['customisation', 'pages']);
            const nextIndex = pages ? pages.count() : 0;

            // $FlowFixMe
            const nextState = state.updateIn(['customisation', 'pages'], currentPages => currentPages || fromJS([]));
            // $FlowFixMe
            return nextState.withMutations(state =>
                state
                    .setIn(
                        ['customisation', 'pages', nextIndex],
                        fromJS({
                            items: [{ id: productId, position: 0, type: 'node' }],
                            position: nextIndex
                        })
                    )
                    .set(
                        'previousCustomisation',
                        !previousCustomisation ? currentCustomisationState : previousCustomisation
                    )
                    .set('nextAddProductPosition', undefined)
                    .set('isAddModeOn', false)
                    .set('isEditModeOn', turnEditModeOn)
                    .set('lastProductAdded', productId)
                    .set('currentPage', nextIndex)
                    .set('hasUnsavedChanges', true)
            );
        }
    }),
    [DASHBOARD_REMOVE_PRODUCTS]: handleReduce((state, { payload: { ids } }) => {
        return ids.reduce((state, id) => {
            const position = dashboardItemPositionById(state.getIn(['customisation', 'pages']), id);

            if (!position) {
                return state;
            }

            const [page, pagePosition] = position.split(':');
            const index = state
                .getIn(['customisation', 'pages', page, 'items'])
                .findIndex(m => m.get('position') === parseInt(pagePosition, 10));

            return state.withMutations(state =>
                state
                    .deleteIn(['customisation', 'pages', page, 'items', index])
                    .setIn(['removedDevices', state.get('removedDevices').size], fromJS({ id, position }))
            );
        }, state);
    }),
    [DASHBOARD_ADD_NEXT_PRODUCT_POSITION]: handleReduce((state, { payload }) => {
        const { position } = payload;
        const positionMap = fromJS({
            page: parseInt(position.split(':')[0], 10),
            position: parseInt(position.split(':')[1], 10)
        });
        // $FlowFixMe
        return state.withMutations(state => state.set('nextAddProductPosition', positionMap).set('isAddModeOn', true));
    }),
    [REMOVE_DEVICE]: handleReduce((state, { payload }) => {
        const { id } = payload;
        const position = dashboardItemPositionById(state.getIn(['customisation', 'pages']), id);

        if (position) {
            const [page, pagePosition] = position.split(':');
            const index = state
                .getIn(['customisation', 'pages', page, 'items'])
                .findIndex(m => m.get('position') === parseInt(pagePosition, 10));

            return state.withMutations(state =>
                state
                    .deleteIn(['customisation', 'pages', page, 'items', index])
                    .setIn(['removedDevices', state.get('removedDevices').size], fromJS({ id, position }))
            );
        }

        return state;
    }),
    [REMOVE_ZONE]: handleReduce((state, { payload }) => {
        const { zoneProducts } = payload;
        if (!zoneProducts.size) {
            return state;
        }
        return zoneProducts.reduce((all, product) => {
            const id = product.get('id');
            const position = dashboardItemPositionById(all.getIn(['customisation', 'pages']), id);
            if (position) {
                const [page, pagePosition] = position.split(':');
                const index = all
                    .getIn(['customisation', 'pages', page, 'items'])
                    .findIndex(m => m.get('position') === parseInt(pagePosition, 10));

                return all.withMutations(tempState =>
                    tempState
                        .deleteIn(['customisation', 'pages', page, 'items', index])
                        .setIn(['removedDevices', all.get('removedDevices').size], fromJS({ id, position }))
                );
            }
            return all;
        }, state);
    }),
    [REMOVE_DEVICE_ERROR]: handleReduce(state => {
        const removedDevices = state.get('removedDevices');

        if (!removedDevices.size) {
            return state;
        }

        return removedDevices.reduce((all, device) => {
            const [page, pagePosition] = device.get('position').split(':');
            const itemToRestore = fromJS({
                id: device.get('id'),
                position: parseInt(pagePosition, 10),
                type: 'node'
            });

            return all.setIn(
                ['customisation', 'pages', page, 'items', all.getIn(['customisation', 'pages', page, 'items']).size],
                itemToRestore
            );
        }, state);
    }),
    [REMOVED_DEVICE]: handleReduce(state => state.set('removedDevices', fromJS([]))),
    [REMOVED_ZONE]: handleReduce(state => state.set('removedDevices', fromJS([]))),
    [HIVE2_UPGRADE_START]: handleReduce((state, { payload: { oldStatProducts } }) => {
        if (oldStatProducts.size === 0) {
            return state;
        }

        return oldStatProducts.reduce((all, product) => {
            const id = product.get('id');
            const position = dashboardItemPositionById(all.getIn(['customisation', 'pages']), id);
            if (position) {
                const [page, pagePosition] = position.split(':');
                const index = all
                    .getIn(['customisation', 'pages', page, 'items'])
                    .findIndex(m => m.get('position') === parseInt(pagePosition, 10));

                return all.deleteIn(['customisation', 'pages', page, 'items', index]);
            }
            return all;
        }, state);
    }),
    [REDIRECT_TO_POSTINSTALL_GROUPS]: handleReduce((state, { payload }) =>
        // $FlowFixMe
        state.set('shouldRedirectToPostinstallGroups', payload)
    )
};

export default handleActions(handlers, initialState);



// WEBPACK FOOTER //
// ./src/core/state/dashboard/index.js